<template>
  <div class="bf-page-header">
    <div class="bf-page-header__text">
      <h1 class="bf-h1">{{ pageTitle }}</h1>
      <p v-if="subtitle" class="bf-subtitle">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.actions" class="bf-page-header__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import { useRoute } from "vue-router";

export default defineComponent({
  name: "PageTitle",
  props: ["pageTitle", "mainTitle", "subtitle"],
  setup() {
    const route = useRoute();

    return {
      route,
    };
  },
});
</script>

<style lang="scss" scoped>
.bf-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 22px;

  &__text {
    flex: 1;
    min-width: 240px;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
}
</style>
